import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLoader } from '../../../Loader/LoaderContext';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  getCurrencySymbol,
  getDisplayCompany,
  getDotColor,
  getStatusClass,
  getStatusDisplayName,
} from '../../../utility/RolesUtility';

import { useToaster } from '../../../Toaster/Toaster';
import FilterPopup from '../Modals/FilterPopup';
import { LeadsDto } from '../../../api/interfaces/LeadsDto';
import DeclinedPopup from '../Modals/DeclinedPopup';
import Pagination from '../usersMangmnt/Pagination';
import { SidebarContext } from '../Sidebar/SidebarContext';
import { handleRedirection } from '../../../utility/navigationHelper';

interface LeadsTableProps {
  leads: LeadsDto[]; // Use DTO for leads prop
}
const getSource: Record<string, string> = {
  INTERNAL: 'Internal',
  REFRAL: 'Refral',
  INBOUND_CALL: 'Inbound Call',
  INT_PROMOTIONS: 'Int Promotions',
  SOCIAL_MEDIA: 'Social Media',
  WEBSITE: 'Website',
};
const InActiveVendors: React.FC = () => {
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  const location = useLocation();
  const path = location.pathname;
  const { showToast } = useToaster();
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState<string>(() => {
    return sessionStorage.getItem('searchQuery') || '';
  });

  const [currentPage, setCurrentPage] = useState<number>(() => {
    const savedPage = sessionStorage.getItem('currentPage');
    return savedPage ? parseInt(savedPage) : 0;
  });

  const [totalElement, setTotalElements] = useState(0);
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRefreshPage, setisRefreshPage] = useState(false);

  const fetchVehicle = async (id: number) => {
    setLoading(true);
    let body: any;
    try {
      let url: any;
      // if (userInfo.roles === "SALES_MANAGER") {
      //           url = API_ENDPOINTS.getSMServicereq;
      //         } else if (userInfo.roles === "SALES_ADMIN") {
      //           url = API_ENDPOINTS.gerServiceReq;
      //         } else if (userInfo.roles === "SALES_TEAM_LEAD") {
      //           url = API_ENDPOINTS.getTlServiceReq;
      //         } else if (userInfo.roles === "SALES_EXECUTIVE") {
      //           url = API_ENDPOINTS.getSEServicereq;
      //         }
      const response = await getService(url + '?leadId=' + id);
      setTimeout(() => {
        if (response.data?.length) {
          navigate(
            '/portals/proposals/viewProposal/viewServiceReq?appUserId=' + id
          );
        }
      }, 300);
    } catch (error) {
      showToast('error', 'error', '');
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, [currentPage, searchQuery, isRefreshPage, location]);
  const handleCreateProposal = async (data: any) => {
    let text: string = '';
    navigate(
      '/portals/proposals/addProposal?leadId=' +
        data.id +
        '&createNewProposal=' +
        'activeVendros'
    );
  };
  const viewDashboard = async (data: any) => {
    await handleRedirection(navigate, data?.vendorUserId);
    localStorage.setItem('vendorId', data.vendorUserId);
    localStorage.setItem('leadId', data.leadId);
    localStorage.setItem('screen', 'inactive');
  };
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    body = {
      page: currentPage,
      search: searchQuery,
    };
    try {
      let url: any;

      url = API_ENDPOINTS.getInActiveVendors;

      const response = await postService(url, body);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      showToast('error', 'error', '');
      console.error('Error fetching vehicle data:', error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } finally {
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const onPageChange = async (page: any) => {
    setCurrentPage(page);
    sessionStorage.setItem('currentPage', page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchQuery = event.target.value;

    // Update state
    setSearchQuery(newSearchQuery);
    setCurrentPage(0);

    // Persist to sessionStorage
    sessionStorage.setItem('searchQuery', newSearchQuery);
    sessionStorage.setItem('currentPage', '0');
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      sessionStorage.removeItem('currentPage');
      sessionStorage.removeItem('searchQuery');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const usersScreen = () => {
    navigate('/portals/proposals/viewProposal');
  };
  const viewLeadType = (user: LeadsDto) => {
    console.log(user);
    if (user.leadType === 'HOSPITAL') {
      navigate(
        '/portals/proposals/viewProposal/previewHospital?leadId=' + user?.leadId
      );
    } else if (user?.leadType === 'COMPANY') {
      navigate(
        '/portals/proposals/viewProposal/previewCompany?leadId=' + user?.leadId
      );
    } else if (user?.leadType === 'EVENT_ORGANIZER') {
      navigate(
        '/portals/proposals/viewProposal/eventPreview?leadId=' + user?.leadId
      );
    }
  };
  const viewServices = (data: any) => {
    navigate(
      '/portals/vendors/inActiveVendor/serviceDetails?bookingid=' + data?.leadId
    );
  };
  const viewProfile = (data: any) => {
    if (
      userInfo?.roles !== 'CONTENT_ADMIN' &&
      userInfo?.roles !== 'PUBLISHER' &&
      userInfo?.roles !== 'CHIEF_EDITOR'
    ) {
      navigate(
        '/portals/vendors/inActiveVendor/ViewDetails?appUserId=' + data?.leadId
      );
    }
  };
  const viewCallBack = (data: any) => {
    if (data.dataType === 'VENDOR') {
      navigate(
        '/portals/vendors/inActiveVendor/viewServiceReq?appUserId=' +
          data?.id +
          '&activeVendors=' +
          'inactivevendors'
      );
      // fetchData(data?.id);
    }
  };
  const fetchData = async (id: number) => {
    setLoading(true);
    let body: any;
    try {
      let url: any;

      const response = await getService(
        API_ENDPOINTS.getActiveServiceReq + '?proposalId=' + id
      );
      setTimeout(() => {
        if (response.data?.length) {
          navigate(
            '/portals/proposals/viewProposal/viewServiceReq?appUserId=' +
              id +
              '&activeVendors=' +
              'vendors'
          );
        }
      }, 300);
    } catch (error) {
      showToast('error', 'error', '');
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const viewPropsoal = (data: any) => {
    navigate(
      '/portals/vendors/inActiveVendor/viewPaymentsDetails?appUserId=' +
        data?.vendorUserId +
        '&vendorUUID=' +
        data?.vendorUserUuId +
        '&type=' +
        data?.type
    );
  };

  return (
    <div className='h-full py-2 w-full relative'>
      <div className='flex items-center mb-3 mt-2 cursor-pointer justify-between'>
        <div className='flex items-center '>
          <h1 className='text-2xl font-bold mb-2 text-[#2D2E2F] mr-3'>
            Inactive Vendors
          </h1>
          <input
            type='text'
            placeholder='search'
            className='p-2 border border-[#D1D5DB] w-[300px] rounded-md mr-3'
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className='overflow-x-auto '>
        <table className='min-w-full bg-white border border-gray-200 '>
          <thead className='bg-gray-100 text-left'>
            <tr>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap'>
                Vendor ID
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap'>
                Company Name
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap'>
                Company Type
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap'>
                Contact Name
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap'>
                Services Expired Date
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap'>
                Proposal & Payments
              </th>
              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap'>
                Callback Request
              </th>

              <th className='px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap'>
                Source
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((user: LeadsDto, index: number) => (
              <tr key={index}>
                <td className='px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap'>
                  {user.vendorUserUuId || 'NA'}
                </td>
                <td
                  className='px-4 py-3 border-b text-sm text-gray-900 font-semibold sticky left-0 z-10 cursor-pointer bg-white whitespace-nowrap'
                  onClick={() => viewProfile(user)}
                >
                  {user?.companyName ? user?.companyName : 'NA'}
                </td>
                <td
                  className='px-4 py-3 border-b text-sm text-blue-500 cursor-pointer  whitespace-nowrap'
                  onClick={() => viewLeadType(user)}
                >
                  {user.leadType
                    ? getDisplayCompany(user.leadType)
                    : getDisplayCompany(user.type)}
                </td>
                <td
                  className='px-4 py-3 border-b text-sm text-blue-500 cursor-pointer  whitespace-nowrap'
                  onClick={() => viewLeadType(user)}
                >
                  {user.contactPersonName ? user.contactPersonName : 'NA'}
                </td>
                <td
                  className='px-4 py-3 border-b text-sm text-blue-500 cursor-pointer  whitespace-nowrap'
                  onClick={() => viewServices(user)}
                >
                  {user.expiryDate ? user.expiryDate : 'NA'}
                </td>
                <td
                  className='px-4 py-3 border-b text-sm cursor-pointer whitespace-nowrap text-blue-500'
                  onClick={() => viewPropsoal(user)}
                >
                  View
                </td>

                <td
                  className={`px-4 py-3 border-b text-sm whitespace-nowrap cursor-pointer ${
                    user?.serviceReqType ? 'text-red-500' : 'text-gray-500'
                  }`}
                  onClick={() => viewCallBack(user)}
                >
                  {user?.callBackDate && user?.serviceReqType === 'EMAIL_REQ'
                    ? 'e-response'
                    : user?.callBackDate
                    ? user.callBackDate
                    : '-'}
                </td>
                <td className='px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap'>
                  <div className='flex justify-between items-center'>
                    {user.source ? getSource[user.source] : 'NA'}{' '}
                    <img
                      src='/images/threeDot.svg'
                      alt='Menu'
                      className='cursor-pointer ml-5'
                      onClick={() => toggleDropdown(index)}
                    />
                    {activeDropdown === index && (
                      <div
                        ref={dropdownRef}
                        className='absolute right-[22px] mt-2 w-48 bg-white px-3 border border-gray-300 rounded-md shadow-lg z-10'
                      >
                        <div className='py-2'>
                          {userInfo?.roles !== 'PUBLISHER' &&
                            userInfo?.roles !== 'CONTENT_ADMIN' &&
                            userInfo?.roles !== 'CHIEF_EDITOR' && (
                              <div
                                onClick={() => handleCreateProposal(user)}
                                className='flex gap-2 items-center w-full cursor-pointer'
                              >
                                {' '}
                                <img src='/images/editIcon.svg' />
                                <a
                                  href='#'
                                  className='block py-2 text-sm text-[#374151] font-normal '
                                >
                                  Create new Proposal
                                </a>
                              </div>
                            )}
                          {(userInfo?.roles === 'PUBLISHER' ||
                            userInfo?.roles === 'CONTENT_ADMIN' ||
                            userInfo?.roles === 'CHIEF_EDITOR' ||
                            userInfo?.roles === 'SALES_ADMIN') && (
                            <div
                              onClick={() => viewDashboard(user)}
                              className='flex gap-2 items-center w-full cursor-pointer'
                            >
                              {' '}
                              <img src='/images/dashboardIcon.svg' />
                              <a
                                href='#'
                                className='block py-2 text-sm text-[#374151] font-normal '
                              >
                                View Dashboard
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!tableData.length && (
          <p className='text-center p-2 bg-white'>No data to display</p>
        )}

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElement={totalElement}
            onPageChange={onPageChange}
            onNext={onNext}
            onPrevious={onPrevious}
          />
        )}
      </div>
    </div>
  );
};

export default InActiveVendors;
